import PageHeader from '@/components/common/PageHeader';
import { useCallback, useState } from 'react';
import CorporationSelectList from '@components/page/CorporationSelectList';
import SeasonList from '@components/page/SeasonList';
import { CorporationListItem } from '@/api/corporation/type';
import { useAuthStore } from '@/store/authStore';

const Season = () => {
    const [item, setItem] = useState<CorporationListItem | undefined>(
        undefined,
    );

    const onCorporationChange = useCallback((row: CorporationListItem) => {
        console.log('클릭된 행:', row.userIdx);
        setItem(row);
    }, []);

    const isUser = useAuthStore(state => state.isUser);
    const userMode = isUser(); // role === 1이면 true
    const showList = userMode || item !== undefined;

    return (
        <>
            <PageHeader
                title="생육작기 관리"
                breadcrumbs={[
                    { label: '홈', href: '/' },
                    { label: '생육관리' },
                    { label: '생육작기 관리', active: true },
                ]}
            />

            <div className="row mt-4">
                <div className="col-xl-12">
                    <div className="row">
                        {/* role이 1(대행사)이 아닐 때만 법인 선택 목록 표시 */}
                        {!userMode && (
                            <div className="col-12 col-md-3">
                                <CorporationSelectList
                                    onRowChange={onCorporationChange}
                                />
                            </div>
                        )}

                        <div
                            className={userMode ? 'col-12' : 'col-12 col-md-9'}
                        >
                            {showList && (
                                <SeasonList
                                    key={item?.userIdx ?? 'user-mode'}
                                    userIdx={item?.userIdx}
                                    userName={item?.userName}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Season;
